// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorLabel_root__95C3M","standalone":"ErrorLabel_standalone___2wDD","startTransiction":"ErrorLabel_startTransiction__LLrJL","text":"ErrorLabel_text__OFOwe"};